(function () {
  "use strict";

  angular.module("virtualFairs")
    .controller("VirtualFairGenerateStatsController", VirtualFairGenerateStatsController);

    VirtualFairGenerateStatsController.$inject = ["VirtualFairService", "virtualFairs"];

  function VirtualFairGenerateStatsController(VirtualFairService, virtualFairs) {
    var vm = this;
    vm.flag = false;
    vm.virtualFairSelected = false;
    vm.generateStats = generateStats;
    vm.statusOptions = [{id: 'all', name: 'All'}, {id: 'attended', name: 'Attended'}, {id: 'confirmed', name: 'Confirmed'}];
    vm.statusSelected = 'all';

    function activate() {
      vm.virtualFairs = virtualFairs
    }

    function generateStats() {
      vm.flag = false;
      vm.query = {};
      vm.query['virtual_fair_id'] = vm.virtualFairSelected;
      vm.query['status'] = vm.statusSelected;
      VirtualFairService.generateStats(vm.query).then(function(response){
        console.log(response);
        vm.flag = true;
      });
    }
    
    activate();
  }
})();
